import { Accordion } from "./accordion";
import { Alert } from "./alert";
import { Button } from "./button";
import { CreditCardInput } from "./cardInput";
import { Checkbox } from "./checkbox";
import { Drawer } from "./drawer";
import { Heading } from "./heading";
import { Input } from "./input";
import { Link } from "./link";
import { Menu } from "./menu";
import { Modal } from "./modal";
import { Popover } from "./popover";
import { Progress } from "./progress";
import { Radio } from "./radio";
import { Sidebar } from "./sidebar";
import { Slider } from "./slider";
import { Switch } from "./switch";
import { Table } from "./table";
import { Text } from "./text";
import { Textarea } from "./textarea";

export const components = {
  Accordion,
  Alert,
  Button,
  CreditCardInput,
  Checkbox,
  Drawer,
  Heading,
  Input,
  Link,
  Menu,
  Modal,
  Popover,
  Progress,
  Radio,
  Slider,
  Switch,
  Table,
  Text,
  Textarea,

  Sidebar,
};
